import { Radio } from '@iwoca/orion';
import { Trans } from '@lingui/macro';
import { useApplicationTable } from 'applicationTable/ApplicationTable.context';
import { useApplicationTableState } from 'contexts/ApplicationTableStateContext/ApplicationTableStateContext';
import { DATE_RANGES } from './MonthsFilter.helper';
import styles from './MonthsFilter.module.css';

export const MonthsFilter = () => {
  const { searchApplicationDateRange } = useApplicationTable();
  const { dateRange, setDateRange } = useApplicationTableState();

  const handleChange = (value: string) => {
    searchApplicationDateRange(value);
    setDateRange(value);
  };

  return (
    <div className={styles.monthsFilters}>
      <h3 className={styles.heading}>
        <Trans>Date range</Trans>
      </h3>
      <p className={styles.subHeading}>
        <Trans>View applications in a certain period as a default.</Trans>
      </p>
      {DATE_RANGES().map((range) => (
        <Radio
          labelProps={{ className: styles.label }}
          key={range.id}
          wrapperClassName={styles.radio}
          label={range.label}
          checked={dateRange === range.id}
          onChange={() => {
            handleChange(range.id);
          }}
        />
      ))}
    </div>
  );
};
